/**
 * @file topic-content-getters
 */

import editGetters from './edit';
import officialProcessGetters from './officialProcess';
import relatedBoardGetters from './relatedBoard';
import replyOperationGetters from './reply-operation';
import renderImgGetters from './renderImg';
import handleTableGetters from './handleTable';

export default {
    ...editGetters,
    ...officialProcessGetters,
    ...relatedBoardGetters,
    ...replyOperationGetters,
    ...renderImgGetters,
    ...handleTableGetters
};
